import React, { useEffect } from 'react';
import { useTheme } from '../../Context/ThemeContext';
import MainHeader from '../../Components/Headers/MainHeader/mainHeader';
import MainContent from '../../Components/MainContent/mainContent';
import styles from './mainPage.module.scss';

const MainPage: React.FC = () => {
  const { setTemplate } = useTheme();


  useEffect(() => {
    setTemplate("none");
    return () => setTemplate("none");
  }, [setTemplate]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, []);

  return (
    <div className={styles.page}>
      <MainHeader />
      <MainContent />
    </div>
  )
}

export default MainPage;
